
const digest = '100e036b5cd49e7642b10f7e00ab3d2e3db82679f9e25f9df934977140253422';
const classes = {"pageLoader":"_pageLoader_hlx97_1","pageLoaderWrapper":"_page-loader-wrapper_hlx97_15"};
const css = `._pageLoader_hlx97_1 {
  position: fixed;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  text-align: center;
  color: #ffffff;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
._pageLoader_hlx97_1 ._page-loader-wrapper_hlx97_15 {
  display: block;
  margin: 30px auto 0 auto;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  